import { caseStatus, CaseStatus, CaseStatusEnum } from 'queries/cases/types';

export const isStepAvailable = (current: CaseStatus, target: CaseStatus): boolean => {
  if (target === caseStatus.diagnosis) return true;

  if (current === caseStatus.diagnosis && target === caseStatus.actions) {
    return true;
  }
  const currentOrder = CaseStatusEnum[current];
  const targetOrder = CaseStatusEnum[target];

  return targetOrder <= currentOrder;
};
